import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  const scrollToTop = () =>
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

  return (
    <section id="about" className="about-section">
      {/* Card 1 — About the business */}
      <div className="about-container about-business">
        <div className="about-text">
          <h2>About Melodia Music</h2>
          <p>
            Melodia Music provides private lessons in{" "}
            <strong>piano, bass, guitar, drums, and trumpet</strong>—plus{" "}
            <strong>audio-engineering training</strong>—for beginners through
            advanced players. Lessons are offered{" "}
            <strong>in person (San Jose)</strong> or
            <strong> online via Zoom</strong>, with a clear
            multi-camera/direct-audio setup so you can see hands, fretboard, and
            session workflow without missing details.
          </p>
          <p>
            For events, our team supports churches, conferences, and bands with{" "}
            <strong>in-house and livestream mixes</strong>,
            <strong> system setup and tuning</strong>, and{" "}
            <strong>recording</strong>. We’re Bay-Area based and available
            <strong> on-site nationwide</strong>.
          </p>

          <ul className="services-list">
            <li>
              1:1 Lessons — Piano, Bass, Guitar, Drums, Trumpet (in person &amp;
              Zoom)
            </li>
            <li>
              Audio Engineering Training — DAW, live sound, mixing workflow
            </li>
            <li>
              Tracks &amp; Software — Running tracks; Logic Pro, Ableton Live,
              MainStage
            </li>
            <li>
              Event Audio — In-house &amp; livestream mixing, system
              setup/tuning, recording
            </li>
          </ul>

          <div className="about-ctas">
            <Link className="btn-ghost" to="/booking" onClick={scrollToTop}>
              Book a Lesson
            </Link>
            <Link className="btn-ghost" to="/audio" onClick={scrollToTop}>
              Request Audio Support
            </Link>
          </div>
        </div>
      </div>

      {/* Card 2 — About the owner */}
      <div className="about-container about-owner">
        <div className="owner-photo">
          <img src="/images/ivankeys.jpg" alt="Ivan Simangas at the keys" />
        </div>

        <div className="owner-text">
          <h3>About Ivan Simangas</h3>
          <p className="owner-subtitle">
            Founder, Melodia Music • Worship &amp; Music Director at Vine Church
            San Jose (English &amp; Spanish) • Bachelor of Music (in progress)
          </p>
          <p>
            I teach with a patient, practical approach—clear goals, customized
            plans, and gig-tested methods. My focus is helping musicians build
            real-world skills that translate to rehearsals, services, sessions,
            and the stage.
          </p>

          <ul className="owner-facts">
            <li>
              <strong>Instruments I teach:</strong> Piano, Bass, Guitar, Drums
            </li>
            <li>
              <strong>Styles:</strong> Classical, Jazz, Gospel, Worship, Salsa,
              Merengue
            </li>
            <li>
              <strong>Software:</strong> Logic Pro, Ableton Live, MainStage
              (tracks &amp; keys rigs)
            </li>
            <li>
              <strong>Formats:</strong> In-person (San Jose) &amp; Zoom
            </li>
            <li>
              <strong>Languages:</strong> English &amp; Spanish
            </li>
            {/* 🔁 CHANGED: replaced Training with Credentials */}
            <li>
              <strong>Credentials:</strong> Bachelor of Music (in progress);
              Software Engineering Immersive Certificate — San José State
              University × Fullstack Academy (2025)
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
